import { render } from "./myOrders.vue?vue&type=template&id=7f3b6738&scoped=true"
import script from "./myOrders.vue?vue&type=script&lang=js"
export * from "./myOrders.vue?vue&type=script&lang=js"

import "./myOrders.vue?vue&type=style&index=0&id=7f3b6738&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f3b6738"]])

export default __exports__